import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://uhwhxvxuwpatlibsfekg.supabase.co';
const supabaseAnonKey = 'sb_publishable_P1zP9gyEn5zAVxT_7NsBxQ_SOgSk-fe';

// Custom storage using both localStorage and sessionStorage as fallback
const customStorage = {
  getItem: (key) => {
    try {
      return window.localStorage.getItem(key) || window.sessionStorage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      window.localStorage.setItem(key, value);
      window.sessionStorage.setItem(key, value);
    } catch (e) {
      console.warn('Storage failed:', e);
    }
  },
  removeItem: (key) => {
    try {
      window.localStorage.removeItem(key);
      window.sessionStorage.removeItem(key);
    } catch (e) {
      console.warn('Storage removal failed:', e);
    }
  },
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: customStorage,
    flowType: 'pkce',
  },
});